<template>
  <transition name="confirm-fade">
    <div v-if="isShowConfirm" class="my-confirm" @click.stop="clickFun('clickCancel')">
      <div id="main_con" class="confirm-content-wrap" @click.stop>
        <div class="order-item">
          <div class="ub ub-ac2">
            <div>
              <img :src="photo" class="photo" />
              <span class="money">￥<label>{{ play_mny }}</label></span>
            </div>
            <img src="../assets/img/关闭 (2).png" class="close-img" @click.stop="clickFun('clickCancel')"/>
          </div>

          <div>
            <span class="key">服务类型</span>
            <div>
              <span @click="chosetype('文字语音条')" :class="play_type == '文字语音条' ? 'tag-on' : 'tag'">文字语音条</span>
              <span @click="chosetype('语音通话')" :class="play_type == '语音通话' ? 'tag-on' : 'tag'" >语音通话</span>
              <span @click="chosetype('游戏陪玩')" :class="play_type == '游戏陪玩' ? 'tag-on' : 'tag'">游戏陪玩</span>
            </div>
          </div>

          <div style="margin-bottom: 0.8em">
            <span class="key">时长</span>
            <div>
              <span @click="chosetime('一小时')" :class="play_time == '一小时' ? 'time-on' : 'time'">一小时</span>
              <span @click="chosetime('一天')" :class="play_time == '一天' ? 'time-on' : 'time'">一天</span>
              <span @click="chosetime('一周')" :class="play_time == '一周' ? 'time-on' : 'time'">一周</span>
              <span @click="chosetime('一个月')" :class="play_time == '一个月' ? 'time-on' : 'time'">一个月</span>
            </div>
          </div>

          <div style="margin-top: 1em;">
            <div class="ub ub-pc">
              <span style="color: red">*</span>
              <span style="font-size: 0.95em">你的微信号</span>
              <input type="text" placeholder="请输入微信号" v-model="wx" class="input-verify"/>
            </div>
          </div>

          <div class="btn-block ub ub-pc ub-ac2">
            <div class="mon">
              <span class="sp1">支付金币:</span>
              <span class="sp2">{{ play_coin }}</span>
            </div>
            <span class="btn ub ub-ac ub-pc" @click="save()">立即下单</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script >
import { mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
      titleText: "操作提示", // 提示框标题
      content: "Say Something ...", // 提示框的内容
      cancelText: "取消", // 取消按钮的文字
      confirmText: "确认", // 确认按钮的文字
      type: "confirm", // 表明弹框的类型：confirm - 确认弹窗（有取消按钮）；alert - 通知弹框（没有取消按钮）
      outerData: null, // 用于记录外部传进来的数据，也可以给外部监听userBehavior，事件的函数提供判断到底是哪个事件触发的
       
      wx:"",
      uid_player:"",
      play_mny: 20,
      play_coin: 10000,
      play_type: "文字语音条",
      play_time: "一小时",
      photo: "http://xhcapp_i.zhuochuangzb.com/photo/photo_boy/1407.jpg",
      mny_config: {},


      v1:"item1",
      v2:"hour"
    };
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    ...mapActions(["act_get_userinfo"]), //引入方法
    show(content, config) {
      this.content = content || "Say Something ...";

      if (Object.prototype.toString.call(config) === "[object Object]") {
        // 确保用户传递的是一个对象
        this.titleText = config.titleText || "操作提示";
        this.cancelText = config.cancelText || "取消";
        this.confirmText = config.confirmText || "确认";
        this.type = config.type || "confirm";
        this.outerData = config.data || null;
      }

      this.isShowConfirm = true;

      //加载数据
      //console.log(JSON.stringify(this.outerData));
      this.photo = this.outerData.photo;
      this.uid_player=this.outerData.uid;
      this.mny_config = this.outerData.mny_config;
      console.log(JSON.stringify(this.mny_config));

      //var h= document.getElementById("main_con").clientHeight;
      //console.log(h);
    },
    hidden() {
      this.isShowConfirm = false;
      this.titleText = "操作提示";
      this.cancelText = "取消";
      this.confirmText = "确认";
      this.type = "confirm";
      this.outerData = null;
    },
    clickFun(type) {
      this.$emit("formBehavior", type, this.outerData);
      this.hidden();
    },

    chosetype(type) {
      this.play_type = type;
      if(type=='文字语音条'){
          this.v1="item1";
      }
      if(type=='语音通话'){
          this.v1="item2";
      }
      if(type=='游戏陪玩'){
          this.v1="item3";
      }
      this.play_mny=this.mny_config[this.v1][this.v2];
    },
    chosetime(time) {
      this.play_time = time;
      if(time=='一小时'){
          this.v2="hour";
      }
      if(time=='一天'){
          this.v2="day";
      }
      if(time=='一周'){
          this.v2="week";
      }
      if(time=='一个月'){
          this.v2="month";
      }
      this.play_mny=this.mny_config[this.v1][this.v2];
    },

    save() {
     var uid = this.$store.state.uid;
     var play_time_integer;
     if(this.play_time=='一小时'){
        play_time_integer=1;
     }else if(this.play_time=='一天'){
         play_time_integer=1*24;
     }else if(this.play_time=='一周'){
         play_time_integer=7*24;
     }else if(this.play_time=='一个月'){
         play_time_integer=30*24;
     }
     console.log(play_time_integer);

     if(this.wx==""){
          this.$toast.bottom("请输入微信号~");
          return false;
     }
     if(this.wx.length<4){
          this.$toast.bottom("请检查微信是否输入正确~");
          return false;
     }
     var data_send={
       "uid_player":this.uid_player,
       "uid_to":uid,
       "order_mny":this.play_mny,
       "pay_mny":this.play_coin,
       "play_type":this.play_type,
       "play_time_ch":this.play_time,
       "play_time":play_time_integer,
       "wx":this.wx,
     };
     var strsend = JSON.stringify(data_send);

      var self = this;
      this.post({
        url: "/App/Create_PlayOrder",
        data: { uid: uid, data: strsend },
        success: function (serve_data) {

            if(serve_data.state=="1"){
              self.$toast.bottom("下单成功~");
              self.hidden();
            }else 
            {
              self.$toast.bottom("下单失败~");
            }
        },
      });
    },
  },
};
</script>

<style scoped>
.my-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/* 进入和出去的动画 */
.confirm-fade-enter-active {
  animation: opacity 0.3s;
}

.confirm-fade-enter-active .confirm-content-wrap {
  animation: scale 0.3s;
}

.confirm-fade-leave-active {
  animation: outOpacity 0.2s;
}
/* 进来的动画 */
@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes scale {
}

/* 出去的动画 */
@keyframes outOpacity {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/* 包裹层容器样式 */
.confirm-content-wrap {
  position: fixed;
  bottom: -13.5rem;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  border-top-left-radius: 0.6rem;
  border-top-right-radius: 0.6rem;

  z-index: 999;
  user-select: none;
}

.order-item {
  padding: 0.8rem;
}
.photo {
  width: 5rem;
  height: 5rem;
  margin-right: 0.5rem;
  border-radius: 0.3rem;
}
.close-img {
  width: 1.5rem;
  height: 1.5rem;
}
.money {
  color: #ee0a24;
}
.key {
  display: inline-block;
  font-size: 0.95rem;
  margin: 0.8rem 0 0.4rem 0;
  color: #333;
}
.tag-on {
  font-size: 0.8rem;
  display: inline-block;
  padding: 0.4rem 0.5rem;
  background-color: #fee7e9;
  color: #ee0a24;
  border-radius: 0.4rem;
  margin-right: 0.8rem;
}
.tag {
  font-size: 0.8rem;
  display: inline-block;
  padding: 0.4rem 0.5rem;
  background-color: #dfdfdf;
  color: #888;
  border-radius: 0.4rem;
  margin-right: 0.8rem;
}
.time {
  font-size: 0.8rem;
  display: inline-block;
  padding: 0.4rem 0.5rem;
  background-color: #dfdfdf;
  color: #888;
  border-radius: 0.4rem;
  margin-right: 0.8rem;
}
.time-on {
  font-size: 0.8rem;
  display: inline-block;
  padding: 0.4rem 0.5rem;
  background-color: #fee7e9;
  color: #ee0a24;
  border-radius: 0.4rem;
  margin-right: 0.8rem;
}
.count {
  margin: 0.8rem 0 0.4rem 0;
}
.count span {
  font-size: 0.8rem;
  display: inline-block;
  background-color: #f7f8fa;
  color: #333;
  border-radius: 0.4rem;
  width: 2rem;
  height: 2rem;
  text-align: center;
  line-height: 2rem;
}
.tag2 {
  margin: 0 0.5rem;
}

.input-verify {
  background-color: transparent;
  margin-left: 0.8rem;
  border: 0;
  outline: 0;
  font-size: 0.9rem;
}
.wechat {
  margin: 1rem 0;
}
.wechat-img {
  width: 1rem;
  margin-right: 0.5rem;
}
.rad {
  border: 2px solid #c9cacd;
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
  background-color: #fff;
  /* padding: .2rem; */
}
.rad_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.mon span {
  font-size: 0.95rem;
}
.mon .sp1 {
  color: #333;
}
.mon .sp2 {
  color: #ff4444;
}
.btn-block {
  margin: 1.8rem 0;
}
.btn {
  width: 35%;
  background-color: #42a5f5;
  height: 2.6rem;
  color: #fff;
  border-radius: 1.3rem;
  font-size: 0.95rem;
}

</style>